import React, {PureComponent} from "react";
import {Mutation} from "react-apollo";
import sendMessageMutation, {optimisticResponse} from "../mutations/sendMessageMutation";
import messagesQuery from "../queries/messagesQuery";
import writeOptimisticMessageToApolloCache from "../functions/writeOptimisticMessageToApolloCache";

function withSendMessage(WrappedComponent) {
    // eslint-disable-next-line react/prefer-stateless-function
    class WithSendMessageContainer extends PureComponent {
        render() {
            return (
                <Mutation mutation={sendMessageMutation}>
                    {(sendMessage, {loading, error}) => {
                        return (
                            <WrappedComponent
                                testID="wrappedComponent"
                                sendMessage={({variables}, dispatchFn) =>
                                    sendMessage({
                                        variables,
                                        optimisticResponse: optimisticResponse({
                                            ...variables,
                                            created: new Date().toISOString(),
                                            sender: this.props.me.anyUser,
                                        }),
                                        update: (
                                            store,
                                            {data: {sendMessage: sendMessageResponse}},
                                        ) => {
                                            writeOptimisticMessageToApolloCache(
                                                {
                                                    sendMessageResponse,
                                                    messagesQuery,
                                                    store,
                                                    variables: {
                                                        chatGroupId: variables.chatGroupId,
                                                        limit: variables.limit,
                                                        origin: variables.origin,
                                                        allowDelinked: variables.allowDelinked,
                                                    },
                                                },
                                                dispatchFn,
                                            );
                                        },
                                    })
                                }
                                messageSending={loading}
                                messageSendingError={error}
                                {...this.props}
                            />
                        );
                    }}
                </Mutation>
            );
        }
    }

    return WithSendMessageContainer;
}

export default withSendMessage;
